const SMART_HEALING_ORIGIN_SESSION_KEY = 'smart_healing_origin_session';
const SMART_HEALING_LINKED_USERS_KEY = 'smart_healing_linked_users';

const normalizeUserNo = (userNo) => {
  const value = String(userNo ?? '').trim();
  return value || null;
};

const readLinkedUsers = () => {
  try {
    const raw = window.localStorage.getItem(SMART_HEALING_LINKED_USERS_KEY);
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {};
    }

    return parsed;
  } catch {
    return {};
  }
};

const writeLinkedUsers = (nextValue) => {
  try {
    window.localStorage.setItem(SMART_HEALING_LINKED_USERS_KEY, JSON.stringify(nextValue));
  } catch {
    // ignore storage failures
  }
};

const normalizeOrigin = (value) => {
  const raw = String(value || '').trim();
  if (!raw) {
    return null;
  }

  try {
    return new URL(raw).origin;
  } catch {
    return null;
  }
};

export const markSmartHealingOriginSession = () => {
  try {
    window.sessionStorage.setItem(SMART_HEALING_ORIGIN_SESSION_KEY, 'true');
  } catch {
    // ignore storage failures
  }
};

export const clearSmartHealingOriginSession = () => {
  try {
    window.sessionStorage.removeItem(SMART_HEALING_ORIGIN_SESSION_KEY);
  } catch {
    // ignore storage failures
  }
};

export const hasSmartHealingOriginSession = () => {
  try {
    return window.sessionStorage.getItem(SMART_HEALING_ORIGIN_SESSION_KEY) === 'true';
  } catch {
    return false;
  }
};

export const markSmartHealingLinkedUser = (userNo) => {
  const normalizedUserNo = normalizeUserNo(userNo);
  if (!normalizedUserNo) {
    return;
  }

  const linkedUsers = readLinkedUsers();
  if (linkedUsers[normalizedUserNo] === true) {
    return;
  }

  writeLinkedUsers({
    ...linkedUsers,
    [normalizedUserNo]: true,
  });
};

export const isSmartHealingLinkedUser = (userNo) => {
  const normalizedUserNo = normalizeUserNo(userNo);
  if (!normalizedUserNo) {
    return false;
  }

  const linkedUsers = readLinkedUsers();
  return linkedUsers[normalizedUserNo] === true;
};

export const getStoredUserNo = () => {
  const fromLocalStorage = (() => {
    try {
      return window.localStorage.getItem('user_no') || window.localStorage.getItem('userNo');
    } catch {
      return null;
    }
  })();

  return normalizeUserNo(fromLocalStorage);
};

export const isSmartHealingReferrer = (referrer, smartHealingUrl) => {
  const referrerOrigin = normalizeOrigin(referrer);
  const smartHealingOrigin = normalizeOrigin(smartHealingUrl);

  if (!referrerOrigin || !smartHealingOrigin) {
    return false;
  }

  return referrerOrigin === smartHealingOrigin;
};
